<template>
    <div class="shadow-custom border-l border-r border-b border-a-gray-d6d6d6 bg-white rounded-lg" v-if="dashboard.length > 0" data-cy="container_history_getfriend_dashboard">
        <div data-cy="btn_history_getfriend_dashboard_banner" @click="clickDashboard()">
            <img class="w-full rounded-tl-lg rounded-tr-lg" data-cy="img_history_getfriend_dashboard" :src="dashboard[0].imageUrl">
        </div>
        <div class="fgf-terms p-5" v-if="isLoaded && config" data-cy="container_history_getfriend_terms">
            <div class="text-14 text-a-black-3b3b3b" data-cy="text_history_getfriend_terms" v-html="config.terms_detail"></div>
        </div>
    </div>
</template>
<script>
//helper
// import Util from '@/helper/Utility.js';
//mixin
import LocaleMixin from "@/mixin/LocaleMixin";
import ModalMixin from "@/mixin/ModalMixin";
//service
import MissionService from "@/module/Mission/service/MissionService.js";

export default {
    name: "DashboardSlider",
    mixins: [LocaleMixin, ModalMixin],
    props: {
        dashboard: { type: Array, required: true },
    },
    data: function() {
        return {
            arrDashboard: [],
            isLoaded: false,
            config: null
        };
    },
    created: async function() {
        let res = await this.getGetFriendConfig();
        console.log('res', res);

        if(res) {
            this.config = this.localeCode == 1033 ? res.en : res.th;
        }
    },
    methods: {
        getGetFriendConfig: function() {
            this.modal.loadingModal.show();
            return new Promise((resolve) => {
                MissionService.apiGetFriendConfig()
                    .subscribe({
                        next: (res) => {
                            this.isLoaded = true;
                            this.modal.loadingModal.hide();
                            resolve(res);
                        },
                        error: (err) => {
                            this.isLoaded = true;
                            this.errorApi(err);
                            this.modal.loadingModal.hide();
                            resolve(null);
                        }
                    });
            });
        },
        clickDashboard: function() {
            if(this.dashboard[0].type != 'link') return;
            
            console.log('clickDashboard', this.dashboard[0])
            if(this.dashboard[0].type == 'link'){
                window.location.href = this.dashboard[0].url;
            }
        }
    },
}
</script>
<style lang="scss">
.fgf-terms{
    ol, ul {
        list-style: auto;
        padding-left: 20px;
        padding-top: 10px;

        li {
            margin-bottom: 5px;
        }
    }

    p{
        strong{
            font-size: 1rem;
            line-height: 1.2;
        }
    }
}
</style>
